import { queryOptions } from "@tanstack/react-query";
import api from "../core/api";
import { Params } from "../types/params";

export const SURVEY_KEYS = {
  all: ["surveys"] as const,
  detail: (id: string) => [...SURVEY_KEYS.all, id] as const,
  list: (params: Params) => [...SURVEY_KEYS.all, params] as const,
} as const;

export const SURVEY_QUERIES = {
  list: (params: Params) => {
    return queryOptions({
      queryKey: SURVEY_KEYS.list(params),
      queryFn: async ({ signal }) => {
        const response = await api.get(`/surveys`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
  detail: (id: string) => {
    return queryOptions({
      queryKey: SURVEY_KEYS.detail(id),
      queryFn: async ({ signal }) => {
        const response = await api.get(`/surveys/${id}`, {
          signal,
        });

        return response.data;
      },
    });
  },
  detailByType: (id: string, type: "assigned" | "submissions", params: Params) => {
    return queryOptions({
      queryKey: [...SURVEY_KEYS.detail(id), type, params] as const,
      queryFn: async ({ signal }) => {
        const response = await api.get(`/surveys/${id}/${type}`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
};
